/*
 * @Descripttion:
 * @Author: zhanghang
 * @Date: 2021-08-03 13:53:55
 * @LastEditors: zhanghang
 * @LastEditTime: 2021-08-03 17:04:57
 */
//注册平台级api
import "../api";
//注册系统模态框页面
import sysModal from "./sysModal";
//注册pc端按钮
import "./sysButton";
// 扩展element-ui
import "./elementui";

import bhc from "./bhc";

import audit from "./audit";

import "./token/checkTokenTimeout";

// 首页菜单页面组件
import Home from "./home/menu";
// index页面组件
import HomeCtrl from "./home/ctrl";

//注入平台全局过滤器
import filters from "../filters";
//注入平台全局自定义指令
import directives from "../directives";
//注入平台PC端自定义指令
import pcDirectives from "./directives";

//用于加载配置完成的页面,预览页面
import output from "../output";

import login from "./login";

//平台图表组件
import charts from "./charts";

function install(Vue) {
  Vue.config.performance = true;
  //按需引入element-ui组件
  Vue.prototype.$ELEMENT = {
    zIndex: 15000
  };
  let startTag = "注入平台pc组件对象 start";
  let endTag = "注入平台pc组件对象 end";
  dsf.performance.mark(startTag);

  Vue.use(bhc);
  Vue.use(sysModal);
  Vue.use(audit);
  Vue.use(Home);
  Vue.use(HomeCtrl);
  Vue.use(filters);
  Vue.use(directives);
  Vue.use(pcDirectives);
  Vue.use(output);
  Vue.use(login);
  Vue.use(charts);
  dsf.performance.mark(endTag);
  dsf.performance.measure("注入平台pc组件对象", startTag, endTag);
}

export default install;

export { install, bhc, filters, directives, output, login };
